/**
 * Support Pop-up Drawer Component
 * Handles FAQ Categories, Questions, Navigation, and Theme Editor block integration.
 */
(() => {
  'use strict';

  const CATEGORY_IMAGES = {
    'Shipping & Delivery':
      'https://cdn.shopify.com/s/files/1/0155/8131/files/shipping_i.png?v=1762515103',
    'Exchanges & Returns':
      'https://cdn.shopify.com/s/files/1/0155/8131/files/return_i.png?v=1762515103',
    Miscellaneous:
      'https://cdn.shopify.com/s/files/1/0155/8131/files/miscellaneous_i.png?v=1762515102',
    'International Orders':
      'https://cdn.shopify.com/s/files/1/0155/8131/files/intl_i.png?v=1762515103',
    'Contact Information':
      'https://cdn.shopify.com/s/files/1/0155/8131/files/contact_i.png?v=1762515103',
    'Fabrics Related':
      'https://cdn.shopify.com/s/files/1/0155/8131/files/fabrics_i.png?v=1762515103',
    'Clothing Related':
      'https://cdn.shopify.com/s/files/1/0155/8131/files/clothing_i.png?v=1762515102',
    'Bulk Orders':
      'https://cdn.shopify.com/s/files/1/0155/8131/files/bulk_i.png?v=1762515103',
  };

  /**
   * Returns default prefilled FAQ data as a fallback if no blocks are configured.
   */
  const getDefaultFaqData = () => ({
    'Shipping & Delivery': [
      {
        question: 'How long does delivery take within India?',
        answer:
          'We dispatch most orders within 48 hours, and delivery within India takes 5 to 7 business days, faster to the metros.',
      },
      {
        question: 'How long does international shipping take?',
        answer:
          'International orders take 7 to 14 business days, with full tracking by email, SMS and WhatsApp.',
      },
      {
        question: 'Do you offer express or priority delivery?',
        answer:
          'No express yet—our artisans aren’t machines. But as we maintain 100% inventory we ship fast from our Gwalior location with lots of love.',
      },
      {
        question: 'Can I choose my delivery date?',
        answer:
          "Not really. Couriers don’t take appointments. But if you have a special request or a time sensitive order (like a gift), feel free to write to us at <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a>, we’ll do our best to help! 💛",
      },
      {
        general: true,
        question: 'What are the shipping charges for India?',
        answer:
          'Free above ₹500. Below that, it’s ₹50 less than your chai and samosa combo.',
      },
      {
        question: 'What are the shipping charges for international orders?',
        answer:
          'International shipping is flat and the same everywhere: free on orders above Rs 10,000, and Rs 2,500 below that. No weight calculation, no country-by-country rate.',
      },
      {
        general: true,
        question: 'How can I track my order?',
        answer:
          "Tracking link lands in your email & SMS as soon as we ship. Stalking allowed. Still need help? Just drop us a message at <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a>, we’re always happy to assist! 💛",
      },
      {
        question: 'Can I change my delivery address after placing an order?',
        answer:
          'Yes, but only before it ships. Once it’s flying, it’s out of our hands.<br> So, if you need to make any edits, reach out quickly and we’ll do our best to help! 🙂📦',
      },
      {
        question: 'What happens if I’m not at home during delivery?',
        answer:
          'No stress. Courier will try again. Worst case? It comes back and we resend.',
      },
      {
        question: 'How soon will my order be dispatched after I place it?',
        answer:
          'Mostly in 24–48 hrs. Artisan-made made to order stuff may take a few extra days of TLC.<br> We shall keep you posted if that is the case. Dont worry.',
      },
      {
        question:
          'Can I place an order now and request to dispatch  after a specific date?',
        answer:
          'Yep! Just leave a note or mail us. Prepaid orders only though. Just leave a note in the "Order Notes" section at checkout, or email us at <a href="mailto:helloji@itokri.com" target="_blank">helloji@itokri.com</a> right after placing your order with your Order ID and preferred dispatch date.',
      },
      {
        question:
          'Do you provide gift-friendly packaging without branding on the outside?',
        answer:
          "Inside looks lovely, but our name’s on the box—logistics over mystery. If you're sending a gift and have special instructions, just mention it in the “Order Notes” at checkout or write to us at <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a> with your order ID right after placing the order.",
      },
      {
        question: 'Can I change or update my shipping address ?',
        answer:
          "Totally, but be quick. Once shipped, even we can’t catch it. If you’ve entered the wrong address or need to make changes, please email us as soon as possible at <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a> with your Order ID and the correct address.",
      },
      {
        question: 'How do you package fragile items?',
        answer:
          'Wrapped like it’s headed to a bestie layered, cushioned, and loved. In rare cases, if anything arrives damaged, don’t worry we’ve got you covered. Just drop us a message at <a href=\'mailto:helloji@itokri.com\' target=\'_blank\'>helloji@itokri.com</a> with photos, and we’ll take care of it.',
      },
      {
        question: 'Are international customs duties included in the price?',
        answer:
          'Nope. Customs is your country’s thing. We don’t make the rules (or the fees).<br> Since every country has different rules, we recommend checking with your local customs office for estimated charges. And if you’d like our help, feel free to ask we’ll be happy to check and give you a rough idea too. 😊',
      },
    ],
    'Exchanges & Returns': [
      {
        general: true,
        question: 'How can  I request an exchange?',
        answer:
          "Just email or WhatsApp us within 7 days. Unused, packed items only. We'll take it from there. Some items are non-returnable/non-exchangeable due to hygiene or safety reasons, you’ll find this mentioned clearly in the product description.",
      },
      {
        question: 'Is there a time limit for exchanges or returns?',
        answer:
          "Yes, 7 days from delivery. After that, even we can’t pull magic. If you wish to raise a request, please reach out to us on <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a> or WhatsApp at <a href='https://wa.me/+917869955644' target='_blank' rel='noopener'>+917869955644</a> with your order ID and reason.",
      },
      {
        question: 'Do I have to pay for return shipping?',
        answer:
          "If your order is over ₹300 and within India, we’ll arrange pickup. Under ₹300? Not eligible. If you’re unsure about your eligibility, feel free to WhatsApp us at <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> or email <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a>, we’re always happy to help! 💛",
      },
      {
        question: 'How long does the return process take?',
        answer:
          "5–7 working days. Once we get the item back, your refund or credit is processed quickly to the source payment method. We’ll keep you updated every step of the way but if you ever feel stuck, just drop us a WhatsApp at <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> or email <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a>. 💛",
      },
      {
        question: 'How long does the exchange process take?',
        answer:
          "Usually 7–10 working days. We’ll ship the new item after checking the returned one. If you have any questions during the process, feel free to WhatsApp us at <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> or email us at <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a>, we’re always happy to assist!",
      },
      {
        question: 'What if my item is damaged or defective on arrival?',
        answer:
          'Oh no! Send us pics within 48 hours we’ll fix it with a refund, replacement, or store credit.<br> Your satisfaction matters deeply to us. 💛',
      },
      {
        question: 'Can I exchange or return an international order?',
        answer:
          "Returns aren’t possible for international orders, but damaged items? Yes, we’ll help. Please reach out to us within 48 hours of delivery at <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a> with photos or a video. We'll do our best to help and find a fair resolution. 💛",
      },
      {
        general: true,
        question: 'What is the process of Refund?',
        answer:
          "Once we get the item and approve it, refund is done in 24–48 hrs. Original payment reversal (credited to your bank/UPI/card within 2–3 working days, depending on your payment provider).<br> <br> We’ll keep you posted via email and WhatsApp at every step. And of course, if you need help or an update, just ping us at <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> or write to <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a>, we’ve got your back! 💛",
      },
      {
        question: 'What if the exchanged item still doesn’t work for me?',
        answer:
          "Only one exchange per order. So choose wisely or chat with us first, we’ll help you decide! Still unsure? Just drop us a message on WhatsApp at <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> or email us at <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a>, we’re here to help!",
      },
      {
        question: 'Does store credit expire?',
        answer:
          "Nope. Use it next week, next month, or next year—it’ll always be waiting for you. Need help applying it to an order?<br> Just ping us on WhatsApp <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>(+917869957726)</a> or drop a line at <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a>.",
      },
    ],
    Miscellaneous: [
      {
        question: 'Do you have a mobile app?',
        answer:
          'Not yet! But our site works like a charm on any phone. App’s cooking stay tuned.',
      },
      {
        question: 'Where are we based and do you have any physical stores?',
        answer:
          'We’re in Gwalior. No stores yet, only online. But every order ships from here, packed with love.',
      },
      {
        question: 'Do you offer product customizations?',
        answer:
          "Sometimes! Ask us we’ll check with the artisan. Just note: custom stuff isn’t returnable. Feel free to reach out to us on WhatsApp at <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> or email us at <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a>.",
      },
      {
        question: 'When is a token amount required for COD orders?',
        answer:
          'We may ask for a small token amount in advance for Cash on Delivery (COD) orders in some cases especially for high-value orders, repeat cancellations, or bulk purchases.<br> This helps us ensure that resources like packaging, time, and artisan efforts don’t go to waste due to last-minute cancellations.<br> If a token is needed, our team will contact you before processing your order.',
      },
      {
        question: 'Do you offer a warranty on your products?',
        answer:
          "Reach out within 48 hours of delivery with photographs, on WhatsApp or at <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a>, and we will sort it out.",
      },
      {
        question: 'What is the tax component in the products you sell?',
        answer:
          'All prices include GST. What you see is what you pay. You’ll get a tax invoice too.',
      },
      {
        question: 'Can I get notified when an out-of-stock product is back?',
        answer:
          'Yes! Hit “Notify Me” on the product page & we’ll email you when it’s back. But to be frank most of the time it does not as its hard to repeat the same design in handmade.',
      },
      {
        question: 'How do I leave a review for a product?',
        answer:
          "You can review us here <br> <a href='https://g.page/r/CbY6erZ12ncQEAE/review' target='_blank'>https://g.page/r/CbY6erZ12ncQEAE/review</a>",
      },
      {
        question: 'How do I know my order is confirmed?',
        answer:
          "You'll get a confirmation via email & SMS. Didn’t get it? Check spam or ping us.",
      },
      {
        question: 'Can I combine multiple orders into one shipment?',
        answer:
          'If they’re placed close together, we’ll try! Email or WhatsApp us quickly.',
      },
      {
        question: 'Ways to earn points',
        answer:
          "Sign up, shop, refer, or celebrate your birthday—points rain like handmade confetti! Check more information here : <a href='https://itokri.com/pages/artisan-rewards-program' target='_blank'>https://itokri.com/pages/artisan-rewards-program</a>",
      },
      {
        general: true,
        question: 'Do you have seasonal sales?',
        answer:
          'At iTokri, we do not offer seasonal sales or fake discounts.<br> We believe in fair and respectful pricing that honours the work of our artisans all year round. Instead of discounts, we focus on creating lasting value through Artisan Rewards, thoughtful gifting, and curated experiences that support our handmade ecosystem.',
      },
      {
        general: true,
        question: 'How Can I redeem my points?',
        answer:
          "Use points at checkout. The higher your cart, the more you can redeem. No expiry! Check more information here :<br> <a href='https://itokri.com/pages/artisan-rewards-program' target='_blank'>https://itokri.com/pages/artisan-rewards-program</a>",
      },
      {
        question: 'How can I unsubscribe from marketing emails?',
        answer:
          'Click “Unsubscribe” at the bottom of any email. We’ll miss you, but no hard feelings!',
      },
      {
        question: 'Do you collaborate with designers?',
        answer:
          "Yes! We love collabs. Email us your work if you vibe with handmade and craft stories. If you're a designer looking to collaborate, drop us a line at <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a>, we’d love to hear from you!",
      },
      {
        question:
          'How can I collaborate with iTokri as an influencer or blogger?',
        answer:
          "If you love crafts + content, email us your profile and idea. Let’s co-create! drop us an email at <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a> with your profile, ideas, and why you'd love to collaborate.",
      },
      {
        question: 'Do you offer gift wrapping or personalised notes?',
        answer:
          'Yes! Leave your message at checkout we’ll wrap it pretty and add your note. Just leave your message in the "Order Notes" section, and we’ll make sure it reaches your loved one with all the warmth and beauty it deserves.',
      },
      {
        question: 'Can I customise the size, color, or design of a product?',
        answer:
          "Sometimes yes! For made-to-order items, size or colour tweaks may be possible—just ask. Just WhatsApp us at <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> or email <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a> with your request, and we’ll get back to you with all the details.",
      },
      {
        question: 'Are there any hidden charges apart from the product price?',
        answer:
          'Nope! GST is included. Shipping is clear. No surprises, no shady extras.',
      },
      {
        question: 'Are all your products genuinely handmade?',
        answer:
          'Every product is made by hand. Some steps use simple machines, a sewing machine for stitching or a charkha for spinning, and where that is the case the technique is named on the product page. Nothing here is factory-made or machine-printed.',
      },
    ],
    'International Orders': [
      {
        general: true,
        question: 'Do you ship internationally?',
        answer:
          'Yes, we ship to 50+ countries. Shipping is flat and global: free above Rs 10,000, and Rs 2,500 below that, the same for every country. For the US and the UK, duties and taxes are paid by us, so nothing is collected on delivery. Elsewhere, customs duty is set by your country and paid to the courier on arrival. We do not ship to Pakistan.',
      },
      {
        question: 'How can I place an international order on iTokri?',
        answer:
          "Add items, enter your global address at checkout, pay securely. We'll take care of the rest. ✈️ Have a specific query about international shipping or need help placing an order from abroad? Just WhatsApp us at <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> or email at <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a>, we’re here to help!",
      },
      {
        question: 'Do I need to create an account to order internationally?',
        answer:
          'Nope! But signing up lets you track, earn rewards, and checkout faster next time.',
      },
      {
        general: true,
        question: 'How much does international shipping cost?',
        answer:
          'International shipping is flat and the same everywhere: free on orders above Rs 10,000, and Rs 2,500 below that. No weight calculation, no country-by-country rate.',
      },
      {
        question: 'Which courier partners handle international deliveries?',
        answer:
          "DHL, FedEx, Aramex, India Post, Delhivery—depends on your location and weight. 💬 Want a specific courier or have a preferred service?<br> Just WhatsApp us at <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> or email <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a> after placing your order—we’ll do our best to accommodate your request!",
      },
      {
        question: 'Can I choose express or priority international shipping?',
        answer:
          'Yes! Message us right after ordering and we’ll check express options for you.',
      },
      {
        question: 'Are customs duties and taxes included in the product price?',
        answer:
          'For orders to the United States and the United Kingdom, yes. Since 14 August 2026 we pay all duties and taxes for you. Your parcel comes to your door and the total at checkout is the final price, with nothing to pay on delivery. For every other country, import duty is set by your government and is paid to the courier when the parcel arrives.',
      },
      {
        question: 'How will I know the customs charges for my country?',
        answer:
          'If you are in the US or the UK, there is nothing to find out. We pay the duties and taxes, and the checkout total is final. For other countries, the courier contacts you with the amount when the parcel reaches customs, and our team can walk you through the notice.',
      },
      {
        question: 'What payment methods do you accept for international orders?',
        answer:
          "Credit cards, PayPal, UPI (for NRIs), and global wallets. No COD. If you face any issues during checkout, just reach out to us on WhatsApp: <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> or email <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a>, we’re happy to help!",
      },
      {
        question: 'Do you accept PayPal for international orders?',
        answer:
          'Yes! Choose PayPal at checkout for a smooth, secure payment.',
      },
      {
        question: 'Can I use store credit or coupons for an international order?',
        answer:
          'Absolutely! Apply store credit or coupons at checkout, just like Indian orders.',
      },
      {
        question: 'Can I return or exchange an international order?',
        answer:
          "Sadly, no returns or exchanges for international orders. They're final sale.<br><br> 🧡 We recommend checking product details carefully before placing your order.<br> And if you need any help in choosing the right product, our team is always happy to assist!<br><br> 📩 Email: <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a> <br>📲 WhatsApp: <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a>",
      },
      {
        question: ' How can I track my international shipment?',
        answer:
          'Tracking link comes via email/SMS after dispatch.<br> Stuck? Ping us we’ll help.',
      },
      {
        question:
          'How do I contact customer service for international order issues?',
        answer:
          "Email <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a> or WhatsApp <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> (Mon–Sat, 10am–6pm IST).",
      },
      {
        question:
          'What should I do if my international package is lost in transit?',
        answer:
          "Message us. We’ll talk to the courier and help you find the best fix.<br><br> 📩 Email: <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a><br> 📲 WhatsApp: <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> <br><br> We’ll coordinate with the courier partner and do everything we can to trace the package or find the best possible solution for you. 💬",
      },
      {
        question: 'What should I do If I receive wrong or defective Product?',
        answer:
          "Please contact us within 48 hours of receiving the package.<br><br> Share your order number along with clear photos of the item received.<br><br> You can reach us at:<br> 📩 Email: <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a> <br> 📲 WhatsApp: <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a><br><br> Once we verify the issue, we’ll offer a suitable resolution whether it’s a replacement, refund, or store credit (based on the situation and item type).",
      },
      {
        question: 'How Can I change my shipping address?',
        answer:
          "If not shipped yet, yes! Message us with your order ID and updated address.<br> 📩 Email: <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a><br> 📲 WhatsApp: <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> <br><br> Once your order is dispatched, we won’t be able to make any changes so the sooner you contact us, the better!",
      },
    ],
    'Contact Information': [
      {
        general: true,
        question: 'How can I contact iTokri customer support?',
        answer:
          "We’re always here to help you! 💛 You can connect with us through any of the following:<br><br> 📲 WhatsApp: <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> (for all purposes) <br> ☎ Toll-Free (India): <a href='tel:18001201269' target='_blank'>1800-1201-269</a><br> 📱 Mobile: <a href='tel:+917773897774' target='_blank'>+91-7773897774</a> <br>📞 Landline (India & International): <a href='tel:+917514012029' target='_blank'>+91-751-4012029</a><br> 📩 Email (All Purposes): <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a><br><br> Our customer care team is available Monday to Saturday, 10:00 AM – 6:00 PM IST.<br> We usually reply within 24 working hours, but often much sooner. 😊",
      },
      {
        question: 'What is your customer care phone number?',
        answer:
          "You can reach iTokri customer care at:<br><br> Toll-Free (India): <a href='tel:18001201269' target='_blank'>1800-1201-269</a> <br> <br> Mobile: <a href='tel:+917773897774' target='_blank'>+91-7773897774</a> <br><br> Landline (India & International): <a href='tel:+917514012029' target='_blank'>+91-751-4012029</a> <br><br> You can also WhatsApp us at <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> or email us at <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a> for quick assistance.",
      },
      {
        question: 'What is your official customer service email ID?',
        answer:
          "Our official customer service email is <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a>.<br> You can write to us for any queries, order updates, collaborations, or support requests whether you’re in India or ordering internationally.",
      },
      {
        question: 'What are your customer service working hours?',
        answer:
          'Our customer service team is available Monday to Saturday, 10:30 AM to 6:30 PM (IST) to assist you with any queries or concerns.',
      },
      {
        question: 'Do you have a WhatsApp number for customer support?',
        answer:
          "Yes! You can reach us on WhatsApp at <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> for all purposes, whether it’s order queries, product information, or general assistance.",
      },
      {
        question: 'Can I message you on social media for queries?',
        answer:
          'Yes! You can send us a message on our official social media pages (Instagram, Facebook, etc.), and our team will respond.',
      },
      {
        question: 'Who should I contact for order-related questions?',
        answer:
          "For any order-related questions at iTokri, you can contact the Customer Care team: <br><br> 📧 Email: <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a> <br><br>📱 WhatsApp:  <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+91-7869957726 (Domestic)</a> / <a href='https://wa.me/+919179336111' target='_blank' rel='noopener'>+91-9179336111 (International)</a> <br><br>📞 Landline: <a href='tel:+917514012029' target='_blank'>+91-751-4012029</a> <br><br> They’ll help you with queries related to order status, delivery, returns, or missing/damaged it",
      },
      {
        question: 'Who should I contact for bulk orders?',
        answer:
          "For bulk orders at iTokri, you can directly contact bulk order team. Here are your options: <br><br>📞 Landline: <a href='tel:+917514012029' target='_blank'>+91-751-4012029</a> <br><br>📱 WhatsApp (Domestic): <a href='https://wa.me/+917869955640' target='_blank' rel='noopener'>+91-7869955640</a> <br><br>🌍 WhatsApp (International): <a href='https://wa.me/+919981953567' target='_blank' rel='noopener'>+91-9981953567</a> <br><br>📧 Email: <a href='mailto:wholesale@itokri.com' target='_blank'>wholesale@itokri.com</a> <br><br>You can also schedule a 30-minute call with us to discuss your requirements, pricing, customization, and timelines. Check this page for more <a href='https://itokri.com/pages/bulk-orders-corporate-gifts' target='_blank'>https://itokri.com/pages/bulk-orders-corporate-gifts</a>",
      },
      {
        question: 'How can I get in touch about a collaboration or partnership?',
        answer:
          "We’d love to hear from you! For brand collaborations, partnerships, or creative projects, please reach out to us at:<br><br> Email: <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a> (mention “Collaboration Proposal” in the subject line) <br><br>WhatsApp: <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+91-7869957726</a> <br><br>Our team will review your proposal and get back to you if it’s a good fit for iTokri’s vision.",
      },
      {
        question: 'How do I contact you regarding damaged or missing products?',
        answer:
          "If you receive a damaged item or find something missing from your order, please contact us within 48 hours of delivery. You can:<br><br> Email: <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a> (with your order number, photos, and details)<br><br> WhatsApp: <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a><br><br> Call (India): <a href='tel:18001201269' target='_blank'>1800-1201-269</a> | <a href='tel:+917773897774' target='_blank'>+91-7773897774</a><br><br> Call (International): <a href='tel:+917514012029' target='_blank'>+91-751-4012029</a> <br><br>Our team will review your case and provide a suitable resolution.",
      },
      {
        question: 'How do I reach out for media or press enquiries?',
        answer:
          'For all media or press-related enquiries, please email us at <a href="mailto:helloji@itokri.com" target="_blank">helloji@itokri.com</a> with the subject line "Media/Press Enquiry" so our team can respond quickly.',
      },
      {
        question: 'Where is iTokri based?',
        answer:
          'iTokri is based in Gwalior, Madhya Pradesh, India. We operate primarily online and currently do not have any physical retail stores.',
      },
      {
        question: 'Do you have a physical store or studio I can visit?',
        answer:
          'iTokri does not have a physical retail store or walk-in studio. We are an online-only platform based in Gwalior, Madhya Pradesh, India. However, all our collections are available to explore and shop directly through our website.',
      },
      {
        question: 'How can I share my feedback or suggestions?',
        answer:
          "You can share your feedback or suggestions with us anytime by: <br><br>Emailing us at <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a> <br><br>WhatsApp messaging us at <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> <br><br>Filling out our Contact Us form on the website We truly value your input it helps us improve and serve you better!",
      },
      {
        question:
          'How do I contact you if I’m an artisan wanting to collaborate?',
        answer:
          "If you are an artisan and would like to collaborate with iTokri, please reach out to us via:<br><br> Email: <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a> <br><br> WhatsApp: <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> <br><br> Share details about your work, craft, and location so our team can review and get back to you.",
      },
      {
        question: 'Do you have a separate helpline for international customers?',
        answer:
          "Yes. International customers can contact us through:<br> Landline: <a href='tel:+917514012029' target='_blank'>+91-751-4012029</a><br> WhatsApp: <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> <br> WhatsApp: <a href='https://wa.me/+919179336111' target='_blank' rel='noopener'>+919179336111</a> <br> Email: <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a>",
      },
      {
        question: 'Can I book a call appointment with your team?',
        answer:
          "Yes, you can! Simply email us at <a href='mailto:helloji@itokri.com' target='_blank'>helloji@itokri.com</a> or WhatsApp us on <a href='https://wa.me/+917869957726' target='_blank' rel='noopener'>+917869957726</a> with your preferred time and topic of discussion. Our team will schedule a call and connect with you accordingly.",
      },
    ],
    'Fabrics Related': [
      {
        question: 'What types of fabrics are available on iTokri?',
        answer:
          'Cotton, silk, block prints, weaves, and rare crafts—there’s fabric here for every story, season, and stitch.',
      },
      {
        general: true,
        question: 'How do I know if a fabric is authentic and not a replica?',
        answer:
          'We source direct from artisans. No knockoffs. Every listing tells you where it’s from.',
      },
      {
        question: 'Are all fabrics hand-printed or handwoven?',
        answer:
          'Not all, but most are. We always mention the technique and process, so you know exactly what you\'re buying.',
      },
      {
        question: 'Can I order fabric in smaller or customised lengths?',
        answer:
          'Fabric is sold in half-metre units, so the length you want is set by the quantity you choose: 2 units for 1 metre, 5 for 2.5 metres. The metre length is shown on the product page before you add to cart.',
      },
      {
        question: 'How can I calculate how much fabric I need for my outfit?',
        answer:
          'Kurta: 2.5m | Blouse: 1m | Dress: 3m+ | Salwar set: 7m. Need help? Message us, we’ll do the math.',
      },
      {
        question: 'Which fabric is best for making everyday wear?',
        answer:
          'Pure cotton, mul, and khadi—soft, breathable, and perfect for daily comfort.',
      },
      {
        question: 'Will the colours fade or bleed after washing?',
        answer:
          'Some bleed may happen in early washes. Hand wash cold, dry in shade to keep colours fresh.',
      },
      {
        question: 'Do your fabrics shrink after the first wash?',
        answer:
          'Natural fabrics may shrink 3–5%. Pre-wash before stitching to avoid surprises.',
      },
      {
        question: 'Can I machine wash or should I hand wash these fabrics?',
        answer:
          'Hand wash is best. If using a machine, go gentle. no heavy spins or harsh detergents.',
      },
      {
        question: 'How should I store delicate fabrics to keep them safe?',
        answer:
          'Wrap in soft cotton and store in a dry, dark place. Avoid plastic it traps moisture.',
      },
      {
        question: 'Will the print or colour be exactly as shown in the pictures?',
        answer:
          'Slight variation (5–7%) is normal. Lighting and screen settings can shift tones a bit.',
      },
      {
        question: 'Do you restock the same fabric designs once sold out?',
        answer:
          'Some return, some don’t. Many are one-of-a-kind. If you love it, don’t wait.',
      },
      {
        question: 'Can I request a matching fabric for an existing outfit?',
        answer:
          'Yes! Send us a pic or product link we’ll help you find the closest match.',
      },
      {
        question: 'Which fabrics are best for summer wear?',
        answer:
          'Cotton, mul, kota doria, and chanderi light, breezy, and heat-friendly.',
      },
      {
        question: 'Which fabrics are suitable for winter clothing?',
        answer:
          'Eri silk, tussar, wool blends, and thicker cottons keep you warm and comfy.',
      },
      {
        question: 'Are any fabrics all-season friendly?',
        answer:
          'Modal silk, linen, and soft cottons are great year-round just layer when needed.',
      },
      {
        question:
          'Do you provide tailoring or stitching services for fabrics bought from iTokri?',
        answer:
          'Yes! Some fabrics come with stitching options check the product page or message us.',
      },
      {
        question: 'Do block prints need special ironing techniques?',
        answer:
          'Yes. iron inside out on low heat. Use a cotton cloth on top to protect the print.',
      },
    ],
    'Clothing Related': [
      {
        general: true,
        question: 'How do I choose the right size for iTokri clothing?',
        answer:
          'Every product page has a detailed size chart. We recommend taking your body measurements and matching them to the chart rather than guessing based on your usual size this ensures a perfect fit.',
      },
      {
        question: 'Are your size charts standard or specific to each product?',
        answer:
          'They’re specific to each product because different crafts and tailoring styles have their own quirks. Each style is measured individually for accuracy.',
      },
      {
        question: 'Can I get a custom size or made-to-measure outfit?',
        answer:
          'Yes ji! If you have unique size needs maybe you want an extra-long kurta or a slightly broader fit  just reach out to us before placing your order. We’ll confirm if our team can stitch it to your measurements. There might be a little extra time needed, but it’s worth it when your outfit feels like it was made just for you.',
      },
      {
        general: true,
        question: 'Do your clothes shrink after the first wash?',
        answer:
          'Most of our fabrics are pre-washed before stitching to minimise shrinkage, but natural fabrics can still shrink a tiny bit (about 2-3%) after the first wash. To keep it safe, we recommend gentle hand wash in cold water and avoiding dryers they can cause more shrinkage.',
      },
      {
        question: 'Can I request a matching dupatta, scarf, or accessory?',
        answer:
          'Of course! If you spot a kurta and dream of pairing it with a matching dupatta, just message us. We’ll check our stock and suggest options, sometimes even show you close-up pictures so you can see how well they match.',
      },
      {
        question: 'Which outfits are best for summer wear?',
        answer:
          'For Indian summers, breathable fabrics are a blessing. Our cotton, mul, and kota doria pieces are absolute favourites airy, comfy, and perfect for the heat. Pair them with light, pastel shades for that fresh, easy-going summer vibe.',
      },
      {
        question: 'Which fabrics and styles are better for winter clothing?',
        answer:
          'Winters call for cosier fabrics. We recommend silk blends, thicker cottons, wool blends, and even layered looks with stoles or jackets. Darker tones and full sleeves are also perfect for the season.',
      },
      {
        question: 'How long does it take to ship a clothing order?',
        answer:
          'Ready-to-ship items go out in 2–3 days. Made-to-order may take 5–7 days.',
      },
      {
        question: 'Do you offer express delivery for clothing?',
        answer:
          'Not yet, but we ship quickly! Most orders dispatch within 48 hours.',
      },
      {
        question: 'Are your fabrics and dyes safe for sensitive skin?',
        answer:
          'We mostly work with skin-friendly dyes, especially azo-free ones for many collections. However, as skin sensitivity varies from person to person, we recommend washing before first wear and doing a small patch test if you have extra-sensitive skin.',
      },
      {
        question:
          'Can I place a bulk order for clothing for weddings, events, or gifting?',
        answer:
          'Yes! We love working on big celebrations. Whether it’s coordinated kurtas for your family wedding or gifts for an event, we can arrange bulk quantities. Just give us the timeline, quantity, and design preferences so we can prepare your order smoothly.',
      },
      {
        question:
          'Do you offer branding or customised packaging for bulk clothing orders?',
        answer:
          'Yes! Share your quantity, theme, and timeline we’ll help plan it all.',
      },
      {
        question: 'Do your clothes have pockets?',
        answer:
          'Some do, some don’t. If pockets are a must-have for you, let us know before ordering and we’ll check.',
      },
      {
        question: 'Do you offer matching outfits for couples or kids?',
        answer:
          'We don’t have a separate couples/kids section yet, but many of our fabrics and designs can be made into matching pieces. Message us with your idea we can suggest ready items or stitch them for you',
      },
      {
        question: 'Can I get an unstitched version of a stitched outfit?',
        answer:
          'Sometimes yes, depending on fabric availability. If you like a ready-made outfit but want it unstitched, we’ll check our fabric stock and let you know.',
      },
      {
        question: 'Do you take custom design orders for special occasions?',
        answer:
          'Yes, but it depends on the craft and time available. If you have a wedding outfit idea or want a unique festive look, reach out well in advance. This gives our artisans enough time to create it beautifully.',
      },
      {
        question:
          'What should I do if my outfit has loose threads or minor defects?',
        answer:
          'Many of our pieces are handcrafted, so tiny irregularities are part of their charm. But if something feels like a real defect like a hole, wrong size, or misprint message us immediately with photos. We’ll arrange a replacement or refund as per our policy.',
      },
    ],
    'Bulk Orders': [
      {
        question:
          'Do you accept bulk orders for both domestic and international customers?',
        answer:
          'Absolutely! 🌏 Whether you’re in India or anywhere else in the world, we’re happy to take bulk orders and ship them right to your doorstep.',
      },
      {
        general: true,
        question: 'Is there a minimum order quantity for bulk purchases?',
        answer:
          'For fabrics available on the website, there is no minimum order quantity (MOQ), you can order any quantity from the available stock.<br><br> For customized fabric orders, the MOQ is 50-100 meters, depending on the type of Fabric.',
      },
      {
        question: 'Do you offer special pricing or discounts for bulk orders?',
        answer:
          "Every bulk order at iTokri is handled personally by our wholesale team. What comes with it is everything around the order: dedicated curation for your lot, a single person coordinating it end to end, quality checks across the whole batch, a GST proforma invoice ahead of the order, and consolidated shipping. To start one, WhatsApp our bulk team on <a href='https://wa.me/+917869955640' target='_blank' rel='noopener'>+91-7869955640</a> within India or <a href='https://wa.me/+919981953567' target='_blank' rel='noopener'>+91-9981953567</a> internationally, or write to <a href='mailto:wholesale@itokri.com' target='_blank'>wholesale@itokri.com</a>.",
      },
      {
        question: 'How do I place a bulk order with iTokri?',
        answer:
          "You can get in touch directly with our bulk order experts for both domestic and international requirements.<br><br> Domestic Bulk Orders (India): WhatsApp at <a href='https://wa.me/+917869955640' target='_blank' rel='noopener'>+91-7869955640</a> or call our landline <a href='tel:+917514012029' target='_blank'>+91-751-4012029</a>.<br><br> International Bulk Orders: WhatsApp at <a href='https://wa.me/+919981953567' target='_blank' rel='noopener'>+91-9981953567</a>.<br><br> Our team will guide you through the process, discuss your requirements, and provide pricing, timelines, and shipping options.",
      },
      {
        question: 'Who should I contact for bulk order enquiries?',
        answer:
          "You can contact Nitin Pamnani, Founder of iTokri, for all bulk order enquiries.<br>📧 Email: <a href='mailto:nitin@itokri.com' target='_blank'>nitin@itokri.com</a><br> 📞 Landline:  <a href='tel:+917514012029' target='_blank'>+91-751-4012029</a><br>📱 WhatsApp (Domestic): <a href='https://wa.me/+917869955640' target='_blank' rel='noopener'>+91-7869955640 (Rashmi)</a><br> 📱 WhatsApp (International): <a href='https://wa.me/+919981953567' target='_blank' rel='noopener'>+91-9981953567 (Varsha)</a><br> Or schedule a 30-minute consultation call with us to discuss your requirements.",
      },
      {
        question:
          'Can I schedule a call with your team to discuss my bulk order needs?',
        answer:
          "Yes! You can book a 30-minute consultation with our founder, Nitin Pamnani, to discuss your requirements in detail. If the timezone doesn’t work for you, simply email him at <a href='mailto:nitin@itokri.com' target='_blank'>nitin@itokri.com</a> or connect with our Bulk experts via WhatsApp at <a href='https://wa.me/+917869955640' target='_blank' rel='noopener'>+91-7869955640 (domestic)</a> or <a href='https://wa.me/+919981953567' target='_blank' rel='noopener'>+91-9981953567 (international)</a>.",
      },
      {
        question: 'Do you provide samples before confirming a bulk order?',
        answer:
          "We do not send samples separately, but you can place a sample order directly through our website. If you need fabric samples specifically, we can provide swatches for your reference. For a bulk order, our wholesale team takes it from there: WhatsApp <a href='https://wa.me/+917869955640' target='_blank' rel='noopener'>+91-7869955640</a> within India or <a href='https://wa.me/+919981953567' target='_blank' rel='noopener'>+91-9981953567</a> internationally, or write to <a href='mailto:wholesale@itokri.com' target='_blank'>wholesale@itokri.com</a>.",
      },
      {
        question: 'Are all products on the website available for bulk ordering?',
        answer:
          'Yes, most products listed on our website can be ordered in bulk, but availability may vary depending on stock levels and artisan production timelines. We recommend confirming the specific items and quantities with our team during your consultation.',
      },
      {
        question:
          'Can I place a bulk order for made-to-order or out-of-stock items?',
        answer:
          'Yes, in most cases we can produce made-to-order items or restock out-of-stock products for bulk orders. Availability and timelines will depend on the craft, artisan schedules, and required quantities, which we’ll confirm during your consultation.',
      },
      {
        question: 'What payment methods are accepted for bulk orders?',
        answer:
          'We accept secure payments via bank transfer, credit/debit cards, and UPI for domestic orders. For international orders, payments can be made through bank transfer or PayPal.',
      },
      {
        question: 'Do you require an advance payment for bulk orders?',
        answer:
          'Yes, we typically require an advance payment to confirm your order, with the remaining balance payable before dispatch. The exact percentage will be discussed during your consultation.',
      },
      {
        question: 'Can I pay in instalments for large orders?',
        answer:
          'Yes, for high-value bulk orders, we can discuss flexible payment terms during your consultation. The instalment plan will depend on the order size and production timeline.',
      },
      {
        question: 'What is the delivery timeline for bulk orders?',
        answer:
          'The delivery timeline depends on your order size, product type, and any customization requirements. We’ll provide a clear, agreed-upon timeline during your consultation so you can plan your inventory smoothly.',
      },
      {
        question: 'Can you arrange express delivery for bulk purchases?',
        answer:
          'Yes, we can arrange express delivery for bulk orders through our partnered courier services. Availability and cost will depend on your location, order size, and product type, which we’ll confirm during your consultation.',
      },
      {
        question: 'Do you ship bulk orders internationally?',
        answer:
          'Yes, we ship bulk orders worldwide through multiple trusted courier partners. You’ll get real-time shipping quotes and options based on your location to ensure smooth and timely delivery.',
      },
      {
        question: 'Who handles shipping for bulk orders?',
        answer:
          'iTokri will arrange shipping for your bulk order through DHL or Aramex, but shipping charges are borne by the customer. The exact cost will depend on the courier service chosen, the total weight, and the delivery location. Our team will share shipping charges before dispatch so you can approve them.',
      },
      {
        question: 'What is your return or exchange policy for bulk orders?',
        answer:
          'Bulk orders are not eligible for return or exchange unless the product delivered is defective or incorrect. In such cases, you must inform us within 48 hours of delivery with photos and order details. Our team will review the issue and guide you on the resolution process.',
      },
      {
        question:
          'What should I do if I receive defective or wrong items in my bulk order?',
        answer:
          "Oh no, we never want that to happen! 💛 If anything in your bulk order isn’t quite right, just drop us an email at <a href='mailto:wholesale@itokri.com' target='_blank'>wholesale@itokri.com</a> within 48 hours of delivery with your order details and clear photos of the issue. Our team will quickly review and guide you on the next steps whether it’s a replacement, correction, or another solution that works best for you. We’re here to make sure your order reaches you just the way you imagined. ✨",
      },
      {
        question:
          'Does iTokri have experience working with international brands and retailers?',
        answer:
          'Yes, iTokri has worked with international brands, designers, and retailers across the US, UK, Europe, Australia, and other regions. 🌏 <br>Our team regularly handles bulk and customised orders for global clients, ensuring smooth communication, secure payments, reliable shipping through DHL & Aramex, and packaging that meets international retail standards.<br><br> We’re used to working with varied requirements from custom fabric production to exclusive product sourcing so whether it’s a boutique order or a large retail project, we can manage it end-to-end.',
      },
      {
        question: 'How does iTokri ensure quality for large-scale orders?',
        answer:
          'At iTokri, quality control for large-scale orders is treated like a non-negotiable promise 💯.<br><br> Here’s how we ensure every bulk order meets our standards:<br><br> Multiple Quality Checks – Every batch goes through inspection at three stages: raw material selection, production, and pre-dispatch.<br><br> Skilled Artisan Network – We work with trusted artisan clusters who are well-versed in maintaining consistency even at high volumes.<br><br> Dedicated Order Monitoring – A bulk-order team tracks progress daily to ensure timelines and quality benchmarks are met.<br><br> Secure, Protective Packaging – Especially important for international shipping, so your order arrives in perfect condition.<br><br> In short, scale doesn’t mean compromise. Whether it’s 50 pieces or 5,000, the care and attention remain the same.',
      },
      {
        question:
          'Do you offer branding or packaging customization for bulk orders?',
        answer:
          'Yes, absolutely!<br> For bulk orders, iTokri can work with you on branding and packaging customizations so your order truly reflects your style or brand identity.<br><br> We offer:<br><br> Custom Tags or Labels with your branding.<br><br> Special Packaging for gifting, retail, or events.<br><br> Personalized Inserts such as thank-you notes or care cards.<br><br> Please note if you’d like us to use your own branded materials (tags, packaging, inserts, etc.), you will need to send them to us in advance. Our team will guide you on quantities and timelines to ensure smooth processing.<br><br> This way, your order not only carries iTokri’s craft but also your brand’s personal touch. ✨',
      },
    ],
  });

  const DEFAULT_CATEGORIES = [
    'Shipping & Delivery',
    'Exchanges & Returns',
    'Miscellaneous',
    'International Orders',
    'Contact Information',
    'Fabrics Related',
    'Clothing Related',
    'Bulk Orders',
  ];

  /**
   * Parses JSON Categories data from the script tag rendered by Liquid.
   * If empty or invalid, falls back to default categories array.
   */
  const getCategoriesData = () => {
    const jsonElement = document.querySelector('[data-cp-categories-json]');
    if (!jsonElement) {
      return DEFAULT_CATEGORIES.map((cat) => ({ id: '', title: cat, icon: '' }));
    }

    try {
      const rawBlocks = JSON.parse(jsonElement.textContent || '[]');
      if (!Array.isArray(rawBlocks) || rawBlocks.length === 0) {
        return DEFAULT_CATEGORIES.map((cat) => ({ id: '', title: cat, icon: '' }));
      }

      const categories = [];
      rawBlocks.forEach((item) => {
        if (typeof item === 'string' && item.trim()) {
          categories.push({
            id: '',
            title: item.trim(),
            icon: '',
          });
        } else if (item && item.title && item.title.trim()) {
          categories.push({
            id: item.id || '',
            title: item.title.trim(),
            icon: item.icon || '',
          });
        }
      });

      return categories.length > 0
        ? categories
        : DEFAULT_CATEGORIES.map((cat) => ({ id: '', title: cat, icon: '' }));
    } catch (error) {
      console.warn('[Support Drawer] Error parsing Categories JSON, using fallback.', error);
      return DEFAULT_CATEGORIES.map((cat) => ({ id: '', title: cat, icon: '' }));
    }
  };

  /**
   * Parses JSON FAQ data from the script tag rendered by Liquid.
   * If empty or invalid, falls back to prefilled default data.
   */
  const getFaqData = () => {
    const jsonElement = document.querySelector('[data-cp-faq-json]');
    if (!jsonElement) {
      return getDefaultFaqData();
    }

    try {
      const rawBlocks = JSON.parse(jsonElement.textContent || '[]');
      if (!Array.isArray(rawBlocks) || rawBlocks.length === 0) {
        return getDefaultFaqData();
      }

      // Group raw blocks by category
      const groupedData = {};
      rawBlocks.forEach((item) => {
        if (!item || !item.category || !item.question) return;
        const categoryKey = item.category.trim();
        if (!groupedData[categoryKey]) {
          groupedData[categoryKey] = [];
        }

        const isGeneral =
          item.general === true ||
          item.general === 'true' ||
          item.general === 1 ||
          item.general === '1';

        groupedData[categoryKey].push({
          id: item.id || '',
          question: item.question.trim(),
          answer: item.answer || '',
          general: isGeneral,
        });
      });

      return Object.keys(groupedData).length > 0 ? groupedData : getDefaultFaqData();
    } catch (error) {
      console.warn('[Support Drawer] Error parsing FAQ JSON data, using fallback.', error);
      return getDefaultFaqData();
    }
  };

  /**
   * HTML template for the support drawer
   */
  const getDrawerTemplate = () => `
    <div class="CP-supportDrawer-overlay" data-cp-support-overlay></div>
    <div class="CP-supportDrawer" data-cp-support-drawer>
      <div class="CP-header" data-cp-drawer-header>
        <div class="CP-header-icons">
          <a class="CP-icon" title="Continue on Phone" href="tel:+917773897774" target="_blank" data-cp-phone-link>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"></path></svg>
          </a>
          <a class="CP-icon" title="Continue on WhatsApp" href="https://wa.me/+917869957726" target="_blank" rel="noopener" data-cp-whatsapp-link>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m17.507 14.307-.009.075c-2.199-1.096-2.429-1.242-2.713-.816-.197.295-.771.964-.944 1.162-.175.195-.349.21-.646.075-.3-.15-1.263-.465-2.403-1.485-.888-.795-1.484-1.77-1.66-2.07-.293-.506.32-.578.878-1.634.1-.21.049-.375-.025-.524-.075-.15-.672-1.62-.922-2.206-.24-.584-.487-.51-.672-.51-.576-.05-.997-.042-1.368.344-1.614 1.774-1.207 3.604.174 5.55 2.714 3.552 4.16 4.206 6.804 5.114.714.227 1.365.195 1.88.121.574-.091 1.767-.721 2.016-1.426.255-.705.255-1.29.18-1.425-.074-.135-.27-.21-.57-.345z"></path><path d="m20.52 3.449c-7.689-7.433-20.414-2.042-20.419 8.444 0 2.096.549 4.14 1.595 5.945l-1.696 6.162 6.335-1.652c7.905 4.27 17.661-1.4 17.665-10.449 0-3.176-1.24-6.165-3.495-8.411zm1.482 8.417c-.006 7.633-8.385 12.4-15.012 8.504l-.36-.214-3.75.975 1.005-3.645-.239-.375c-4.124-6.565.614-15.145 8.426-15.145 2.654 0 5.145 1.035 7.021 2.91 1.875 1.859 2.909 4.35 2.909 6.99z"></path></svg>
          </a>
          <a class="CP-icon" title="Continue on Email" href="mailto:helloji@itokri.com" target="_blank" data-cp-email-link>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M467,61H45c-6.927,0-13.412,1.703-19.279,4.51L255,294.789l51.389-49.387c0,0,0.004-0.005,0.005-0.007 c0.001-0.002,0.005-0.004,0.005-0.004L486.286,65.514C480.418,62.705,473.929,61,467,61z"></path><path d="M507.496,86.728L338.213,256.002L507.49,425.279c2.807-5.867,4.51-12.352,4.51-19.279V106 C512,99.077,510.301,92.593,507.496,86.728z"></path><path d="M4.51,86.721C1.703,92.588,0,99.073,0,106v300c0,6.923,1.701,13.409,4.506,19.274L173.789,256L4.51,86.721z"></path><path d="M317.002,277.213l-51.396,49.393c-2.93,2.93-6.768,4.395-10.605,4.395s-7.676-1.465-10.605-4.395L195,277.211 L25.714,446.486C31.582,449.295,38.071,451,45,451h422c6.927,0,13.412-1.703,19.279-4.51L317.002,277.213z"></path></svg>
          </a>
        </div>
        <span class="CP-close" data-cp-close-btn>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M11.414 10l6.293-6.293a1 1 0 10-1.414-1.414L10 8.586 3.707 2.293a1 1 0 00-1.414 1.414L8.586 10l-6.293 6.293a1 1 0 101.414 1.414L10 11.414l6.293 6.293A.998.998 0 0018 17a.999.999 0 00-.293-.707L11.414 10z"></path></svg>
        </span>
      </div>

      <div class="CP-body" data-cp-drawer-body>
        <div class="CP-page CP-page-main active" data-cp-page="main">
          <h3>FAQ Categories</h3>
          <div class="CP-categories" data-cp-categories-container></div>
          <h3>General Queries</h3>
          <div class="CP-general" data-cp-general-container></div>
        </div>

        <div class="CP-page CP-page-category" data-cp-page="category">
          <div class="CP-category-header">
            <button class="CP-back" data-cp-back-btn type="button" aria-label="Back">
              <svg viewBox="0 0 20 20"><path d="M17 9H5.414l3.293-3.293a.999.999 0 1 0-1.414-1.414l-5 5a.999.999 0 0 0 0 1.414l5 5a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L5.414 11H17a1 1 0 1 0 0-2z"></path></svg>
            </button>
            <h3 class="CP-category-title" data-cp-category-title></h3>
          </div>
          <div class="CP-category-questions" data-cp-category-questions></div>
        </div>

        <div class="CP-page CP-page-answer" data-cp-page="answer">
          <div class="CP-category-header">
            <button class="CP-back" data-cp-back-btn type="button" aria-label="Back">
              <svg viewBox="0 0 20 20"><path d="M17 9H5.414l3.293-3.293a.999.999 0 1 0-1.414-1.414l-5 5a.999.999 0 0 0 0 1.414l5 5a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L5.414 11H17a1 1 0 1 0 0-2z"></path></svg>
            </button>
            <h3 class="CP-answer-question" data-cp-answer-question></h3>
          </div>
          <span class="CP-answer-category" data-cp-answer-category></span>
          <p class="CP-answer-text" data-cp-answer-text></p>

          <div class="CP-answer-navigation" data-cp-answer-nav>
            <div class="CP-prev" data-cp-prev style="display:none;">
              <button class="CP-prev-btn" data-cp-prev-btn type="button" aria-label="Previous question">
                <svg viewBox="0 0 20 20"><path d="M17 9H5.414l3.293-3.293a.999.999 0 1 0-1.414-1.414l-5 5a.999.999 0 0 0 0 1.414l5 5a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L5.414 11H17a1 1 0 1 0 0-2z"></path></svg>
              </button>
              <span class="CP-prev-que" data-cp-prev-que></span>
            </div>
            <div class="CP-next" data-cp-next style="display:none;">
              <button class="CP-next-btn" data-cp-next-btn type="button" aria-label="Next question">
                <svg viewBox="0 0 20 20"><path d="M17.707 9.293l-5-5a.999.999 0 10-1.414 1.414L14.586 9H3a1 1 0 100 2h11.586l-3.293 3.293a.999.999 0 101.414 1.414l5-5a.999.999 0 000-1.414z"></path></svg>
              </button>
              <span class="CP-next-que" data-cp-next-que></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;

  const DEFAULT_PHONE_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"></path></svg>`;
  const DEFAULT_WHATSAPP_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m17.507 14.307-.009.075c-2.199-1.096-2.429-1.242-2.713-.816-.197.295-.771.964-.944 1.162-.175.195-.349.21-.646.075-.3-.15-1.263-.465-2.403-1.485-.888-.795-1.484-1.77-1.66-2.07-.293-.506.32-.578.878-1.634.1-.21.049-.375-.025-.524-.075-.15-.672-1.62-.922-2.206-.24-.584-.487-.51-.672-.51-.576-.05-.997-.042-1.368.344-1.614 1.774-1.207 3.604.174 5.55 2.714 3.552 4.16 4.206 6.804 5.114.714.227 1.365.195 1.88.121.574-.091 1.767-.721 2.016-1.426.255-.705.255-1.29.18-1.425-.074-.135-.27-.21-.57-.345z"></path><path d="m20.52 3.449c-7.689-7.433-20.414-2.042-20.419 8.444 0 2.096.549 4.14 1.595 5.945l-1.696 6.162 6.335-1.652c7.905 4.27 17.661-1.4 17.665-10.449 0-3.176-1.24-6.165-3.495-8.411zm1.482 8.417c-.006 7.633-8.385 12.4-15.012 8.504l-.36-.214-3.75.975 1.005-3.645-.239-.375c-4.124-6.565.614-15.145 8.426-15.145 2.654 0 5.145 1.035 7.021 2.91 1.875 1.859 2.909 4.35 2.909 6.99z"></path></svg>`;
  const DEFAULT_EMAIL_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M467,61H45c-6.927,0-13.412,1.703-19.279,4.51L255,294.789l51.389-49.387c0,0,0.004-0.005,0.005-0.007 c0.001-0.002,0.005-0.004,0.005-0.004L486.286,65.514C480.418,62.705,473.929,61,467,61z"></path><path d="M507.496,86.728L338.213,256.002L507.49,425.279c2.807-5.867,4.51-12.352,4.51-19.279V106 C512,99.077,510.301,92.593,507.496,86.728z"></path><path d="M4.51,86.721C1.703,92.588,0,99.073,0,106v300c0,6.923,1.701,13.409,4.506,19.274L173.789,256L4.51,86.721z"></path><path d="M317.002,277.213l-51.396,49.393c-2.93,2.93-6.768,4.395-10.605,4.395s-7.676-1.465-10.605-4.395L195,277.211 L25.714,446.486C31.582,449.295,38.071,451,45,451h422c6.927,0,13.412-1.703,19.279-4.51L317.002,277.213z"></path></svg>`;

  const DEFAULT_HEADER_CONTACT = {
    phone: {
      show: true,
      url: 'tel:+917773897774',
      tooltip: 'Continue on Phone',
      icon: '',
    },
    whatsapp: {
      show: true,
      url: 'https://wa.me/+917869957726',
      tooltip: 'Continue on WhatsApp',
      icon: '',
    },
    email: {
      show: true,
      url: 'mailto:helloji@itokri.com',
      tooltip: 'Continue on Email',
      icon: '',
    },
  };

  /**
   * Parses JSON Header Contact channels from the script tag rendered by Liquid.
   */
  const getHeaderContactData = () => {
    const jsonElement = document.querySelector('[data-cp-header-contact-json]');
    if (!jsonElement) {
      return DEFAULT_HEADER_CONTACT;
    }

    try {
      const rawData = JSON.parse(jsonElement.textContent || '{}');
      return {
        phone: {
          show: rawData.phone ? (rawData.phone.show === true || rawData.phone.show === 'true' || rawData.phone.show === 1) : true,
          url: rawData.phone && rawData.phone.url ? String(rawData.phone.url).trim() : DEFAULT_HEADER_CONTACT.phone.url,
          tooltip: rawData.phone && rawData.phone.tooltip ? String(rawData.phone.tooltip).trim() : DEFAULT_HEADER_CONTACT.phone.tooltip,
          icon: rawData.phone && rawData.phone.icon ? String(rawData.phone.icon).trim() : '',
        },
        whatsapp: {
          show: rawData.whatsapp ? (rawData.whatsapp.show === true || rawData.whatsapp.show === 'true' || rawData.whatsapp.show === 1) : true,
          url: rawData.whatsapp && rawData.whatsapp.url ? String(rawData.whatsapp.url).trim() : DEFAULT_HEADER_CONTACT.whatsapp.url,
          tooltip: rawData.whatsapp && rawData.whatsapp.tooltip ? String(rawData.whatsapp.tooltip).trim() : DEFAULT_HEADER_CONTACT.whatsapp.tooltip,
          icon: rawData.whatsapp && rawData.whatsapp.icon ? String(rawData.whatsapp.icon).trim() : '',
        },
        email: {
          show: rawData.email ? (rawData.email.show === true || rawData.email.show === 'true' || rawData.email.show === 1) : true,
          url: rawData.email && rawData.email.url ? String(rawData.email.url).trim() : DEFAULT_HEADER_CONTACT.email.url,
          tooltip: rawData.email && rawData.email.tooltip ? String(rawData.email.tooltip).trim() : DEFAULT_HEADER_CONTACT.email.tooltip,
          icon: rawData.email && rawData.email.icon ? String(rawData.email.icon).trim() : '',
        },
      };
    } catch (error) {
      console.warn('[Support Drawer] Error parsing Header Contact JSON, using fallback.', error);
      return DEFAULT_HEADER_CONTACT;
    }
  };

  // Module-scoped persistent drawer state
  let lastPage = 'main';
  let currentCategory = '';
  let currentIndex = -1;
  let currentBlockId = '';

  /**
   * Renders the drawer contents and attaches event listeners.
   */
  const renderDrawer = (drawerElement) => {
    if (!drawerElement) return;

    const headerContact = getHeaderContactData();
    const categoriesList = getCategoriesData();
    const faqData = getFaqData();

    // Sync header contact icons
    const phoneLink = drawerElement.querySelector('[data-cp-phone-link]');
    const whatsappLink = drawerElement.querySelector('[data-cp-whatsapp-link]');
    const emailLink = drawerElement.querySelector('[data-cp-email-link]');

    if (phoneLink) {
      if (headerContact.phone.show && headerContact.phone.url) {
        phoneLink.style.display = 'flex';
        phoneLink.href = headerContact.phone.url;
        phoneLink.title = headerContact.phone.tooltip;
        if (headerContact.phone.icon) {
          phoneLink.innerHTML = `<img src="${headerContact.phone.icon}" alt="${headerContact.phone.tooltip}" width="18" height="18" style="object-fit:contain;width:18px;height:18px;border-radius:50%;">`;
        } else {
          phoneLink.innerHTML = DEFAULT_PHONE_SVG;
        }
      } else {
        phoneLink.style.display = 'none';
      }
    }

    if (whatsappLink) {
      if (headerContact.whatsapp.show && headerContact.whatsapp.url) {
        whatsappLink.style.display = 'flex';
        whatsappLink.href = headerContact.whatsapp.url;
        whatsappLink.title = headerContact.whatsapp.tooltip;
        if (headerContact.whatsapp.icon) {
          whatsappLink.innerHTML = `<img src="${headerContact.whatsapp.icon}" alt="${headerContact.whatsapp.tooltip}" width="18" height="18" style="object-fit:contain;width:18px;height:18px;border-radius:50%;">`;
        } else {
          whatsappLink.innerHTML = DEFAULT_WHATSAPP_SVG;
        }
      } else {
        whatsappLink.style.display = 'none';
      }
    }

    if (emailLink) {
      if (headerContact.email.show && headerContact.email.url) {
        emailLink.style.display = 'flex';
        emailLink.href = headerContact.email.url;
        emailLink.title = headerContact.email.tooltip;
        if (headerContact.email.icon) {
          emailLink.innerHTML = `<img src="${headerContact.email.icon}" alt="${headerContact.email.tooltip}" width="18" height="18" style="object-fit:contain;width:18px;height:18px;border-radius:50%;">`;
        } else {
          emailLink.innerHTML = DEFAULT_EMAIL_SVG;
        }
      } else {
        emailLink.style.display = 'none';
      }
    }

    const categoriesContainer = drawerElement.querySelector('[data-cp-categories-container]');
    const generalContainer = drawerElement.querySelector('[data-cp-general-container]');
    const mainPage = drawerElement.querySelector('[data-cp-page="main"]');
    const categoryPage = drawerElement.querySelector('[data-cp-page="category"]');
    const answerPage = drawerElement.querySelector('[data-cp-page="answer"]');
    const categoryTitle = drawerElement.querySelector('[data-cp-category-title]');
    const categoryQuestions = drawerElement.querySelector('[data-cp-category-questions]');
    const answerQuestion = drawerElement.querySelector('[data-cp-answer-question]');
    const answerCategory = drawerElement.querySelector('[data-cp-answer-category]');
    const answerText = drawerElement.querySelector('[data-cp-answer-text]');
    const backButtons = drawerElement.querySelectorAll('[data-cp-back-btn]');
    const prevContainer = drawerElement.querySelector('[data-cp-prev]');
    const nextContainer = drawerElement.querySelector('[data-cp-next]');
    const prevQue = drawerElement.querySelector('[data-cp-prev-que]');
    const nextQue = drawerElement.querySelector('[data-cp-next-que]');

    // Updates Previous / Next Navigation in Answer Page
    const updateNavigation = (list, index) => {
      if (!list || list.length === 0) return;

      if (index > 0) {
        const prevItem = list[index - 1];
        if (prevContainer) prevContainer.style.display = 'flex';
        if (prevQue) prevQue.textContent = prevItem.question;
      } else if (prevContainer) {
        prevContainer.style.display = 'none';
      }

      if (index < list.length - 1) {
        const nextItem = list[index + 1];
        if (nextContainer) nextContainer.style.display = 'flex';
        if (nextQue) nextQue.textContent = nextItem.question;
      } else if (nextContainer) {
        nextContainer.style.display = 'none';
      }
    };

    // Opens Answer Page and updates Next/Prev navigation
    const openAnswerPage = (categoryName, answerObj, list, index) => {
      currentCategory = categoryName;
      currentIndex = index;
      currentBlockId = (answerObj && answerObj.id) ? answerObj.id : '';

      if (answerQuestion) answerQuestion.textContent = answerObj.question;
      if (answerCategory) answerCategory.textContent = categoryName;
      if (answerText) answerText.innerHTML = answerObj.answer;

      if (mainPage) mainPage.classList.remove('active');
      if (categoryPage) categoryPage.classList.remove('active');
      if (answerPage) answerPage.classList.add('active');

      updateNavigation(list, index);
    };

    // Render questions list for a specific category
    const renderCategoryQuestions = (categoryName, iconUrl) => {
      if (!categoryQuestions) return;
      categoryQuestions.innerHTML = '';
      if (categoryTitle) categoryTitle.textContent = categoryName;

      const categoryIconSrc = iconUrl || CATEGORY_IMAGES[categoryName] || '';
      const questionsList = faqData[categoryName] || [];

      questionsList.forEach((item, index) => {
        const questionElement = document.createElement('div');
        questionElement.className = 'CP-question';
        questionElement.setAttribute('data-cp-question-item', '');
        if (item.id) questionElement.setAttribute('data-cp-block-id', item.id);
        questionElement.innerHTML = `
          <img src="${categoryIconSrc}" alt="${categoryName}" width="30" height="30">
          <div>
            <strong>${item.question}</strong>
            <small>${categoryName}</small>
          </div>
        `;
        questionElement.addEventListener('click', () => {
          lastPage = 'category';
          openAnswerPage(categoryName, item, questionsList, index);
        });
        categoryQuestions.appendChild(questionElement);
      });
    };

    // Render Categories on Main Page in the exact order configured in Customizer
    if (categoriesContainer) {
      categoriesContainer.innerHTML = '';
      categoriesList.forEach((catObj) => {
        const categoryName = catObj.title;
        const categoryIconSrc = catObj.icon || CATEGORY_IMAGES[categoryName] || '';
        const categoryElement = document.createElement('div');
        categoryElement.className = 'CP-category';
        categoryElement.setAttribute('data-cp-category-item', categoryName);
        if (catObj.id) categoryElement.setAttribute('data-cp-block-id', catObj.id);
        categoryElement.innerHTML = `
          <div class="CP-category-icon">
            <img src="${categoryIconSrc}" alt="${categoryName}" width="30" height="30">
          </div>
          <span>${categoryName}</span>
        `;

        categoryElement.addEventListener('click', () => {
          currentCategory = categoryName;
          renderCategoryQuestions(categoryName, categoryIconSrc);
          if (mainPage) mainPage.classList.remove('active');
          if (categoryPage) categoryPage.classList.add('active');
          lastPage = 'category';
        });

        categoriesContainer.appendChild(categoryElement);
      });
    }

    // Render General Queries on Main Page
    if (generalContainer) {
      generalContainer.innerHTML = '';
      categoriesList.forEach((catObj) => {
        const categoryName = catObj.title;
        const categoryIconSrc = catObj.icon || CATEGORY_IMAGES[categoryName] || '';
        const questionsList = faqData[categoryName] || [];
        questionsList.forEach((item, index) => {
          if (!item.general) return;
          const questionElement = document.createElement('div');
          questionElement.className = 'CP-question';
          questionElement.setAttribute('data-cp-general-item', '');
          if (item.id) questionElement.setAttribute('data-cp-block-id', item.id);
          questionElement.innerHTML = `
            <img src="${categoryIconSrc}" alt="${categoryName}" width="30" height="30">
            <div>
              <strong>${item.question}</strong>
              <small>${categoryName}</small>
            </div>
          `;
          questionElement.addEventListener('click', () => {
            lastPage = 'main';
            openAnswerPage(categoryName, item, questionsList, index);
          });
          generalContainer.appendChild(questionElement);
        });
      });
    }

    // If Category page is currently open, refresh its questions list
    if (categoryPage && categoryPage.classList.contains('active') && currentCategory) {
      const catObj = categoriesList.find((c) => c.title === currentCategory);
      const iconUrl = catObj ? (catObj.icon || CATEGORY_IMAGES[currentCategory]) : CATEGORY_IMAGES[currentCategory];
      renderCategoryQuestions(currentCategory, iconUrl);
    }

    // If Answer page is currently open, synchronize live question/answer content
    if (answerPage && answerPage.classList.contains('active')) {
      let matchedItem = null;
      let matchedCategory = currentCategory;
      let matchedIndex = currentIndex;

      // Match by current block ID first
      if (currentBlockId) {
        Object.entries(faqData).forEach(([cat, list]) => {
          list.forEach((item, idx) => {
            if (item.id && (item.id === currentBlockId || currentBlockId.includes(item.id))) {
              matchedItem = item;
              matchedCategory = cat;
              matchedIndex = idx;
            }
          });
        });
      }

      // Fallback match by category and index
      if (!matchedItem && matchedCategory && faqData[matchedCategory] && faqData[matchedCategory][matchedIndex]) {
        matchedItem = faqData[matchedCategory][matchedIndex];
      }

      // Fallback match by question text
      if (!matchedItem && answerQuestion && answerQuestion.textContent) {
        const currentQText = answerQuestion.textContent.trim();
        Object.entries(faqData).forEach(([cat, list]) => {
          list.forEach((item, idx) => {
            if (item.question.trim() === currentQText) {
              matchedItem = item;
              matchedCategory = cat;
              matchedIndex = idx;
            }
          });
        });
      }

      if (matchedItem) {
        currentCategory = matchedCategory;
        currentIndex = matchedIndex;
        currentBlockId = matchedItem.id || '';
        if (answerQuestion) answerQuestion.textContent = matchedItem.question;
        if (answerCategory) answerCategory.textContent = matchedCategory;
        if (answerText) answerText.innerHTML = matchedItem.answer;
        const currentList = faqData[matchedCategory] || [];
        updateNavigation(currentList, matchedIndex);
      }
    }

    // Back buttons handler
    backButtons.forEach((button) => {
      button.onclick = () => {
        if (answerPage && answerPage.classList.contains('active')) {
          answerPage.classList.remove('active');
          if (lastPage === 'category' && categoryPage) {
            categoryPage.classList.add('active');
          } else if (mainPage) {
            mainPage.classList.add('active');
          }
        } else if (categoryPage && categoryPage.classList.contains('active')) {
          categoryPage.classList.remove('active');
          if (mainPage) mainPage.classList.add('active');
          lastPage = 'main';
        }
      };
    });

    // Previous Button click handler
    if (prevContainer) {
      prevContainer.onclick = () => {
        const list = faqData[currentCategory];
        if (list && currentIndex > 0) {
          currentIndex -= 1;
          const prevItem = list[currentIndex];
          currentBlockId = prevItem.id || '';
          if (answerQuestion) answerQuestion.textContent = prevItem.question;
          if (answerText) answerText.innerHTML = prevItem.answer;
          updateNavigation(list, currentIndex);
        }
      };
    }

    // Next Button click handler
    if (nextContainer) {
      nextContainer.onclick = () => {
        const list = faqData[currentCategory];
        if (list && currentIndex < list.length - 1) {
          currentIndex += 1;
          const nextItem = list[currentIndex];
          currentBlockId = nextItem.id || '';
          if (answerQuestion) answerQuestion.textContent = nextItem.question;
          if (answerText) answerText.innerHTML = nextItem.answer;
          updateNavigation(list, currentIndex);
        }
      };
    }
  };

  /**
   * Initializes drawer UI, event listeners, and navigation flow.
   */
  const handleOpenDrawer = () => {
    let drawerElement = document.querySelector('[data-cp-support-drawer]');
    let overlayElement = document.querySelector('[data-cp-support-overlay]');

    if (!drawerElement) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      document.body.insertAdjacentHTML('beforeend', getDrawerTemplate());

      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
      }

      drawerElement = document.querySelector('[data-cp-support-drawer]');
      overlayElement = document.querySelector('[data-cp-support-overlay]');
      if (!drawerElement) return;

      const handleCloseDrawer = () => {
        drawerElement.remove();
        if (overlayElement) overlayElement.remove();
        document.body.style.paddingRight = '';
      };

      const closeButton = drawerElement.querySelector('[data-cp-close-btn]');
      if (closeButton) {
        closeButton.addEventListener('click', handleCloseDrawer);
      }
      if (overlayElement) {
        overlayElement.addEventListener('click', handleCloseDrawer);
      }
    }

    renderDrawer(drawerElement);
  };

  /**
   * Central trigger binding for support pop-up button.
   */
  const initSupportDrawer = () => {
    const triggerButtons = document.querySelectorAll('[data-cp-support-btn], .CP-support-btn');
    triggerButtons.forEach((button) => {
      button.removeEventListener('click', handleOpenDrawer);
      button.addEventListener('click', handleOpenDrawer);
    });
  };

  // Lifecycle Initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSupportDrawer);
  } else {
    initSupportDrawer();
  }

  // Shopify Theme Editor Integration (Live preview support)
  document.addEventListener('shopify:section:load', (event) => {
    initSupportDrawer();
    const drawerElement = document.querySelector('[data-cp-support-drawer]');
    if (drawerElement) {
      renderDrawer(drawerElement);
    }
  });

  document.addEventListener('shopify:section:select', (event) => {
    if (event.detail && event.detail.sectionId && event.detail.sectionId.includes('cp-support')) {
      handleOpenDrawer();
    }
  });

  document.addEventListener('shopify:block:select', (event) => {
    const selectedBlockId = event.detail && event.detail.blockId;
    handleOpenDrawer();
    const drawerElement = document.querySelector('[data-cp-support-drawer]');
    if (!drawerElement || !selectedBlockId) return;

    const categoriesList = getCategoriesData();
    const faqData = getFaqData();

    // Check if a category block was selected
    const matchedCategoryObj = categoriesList.find(
      (cat) => cat.id && (cat.id === selectedBlockId || selectedBlockId.includes(cat.id))
    );

    if (matchedCategoryObj) {
      currentCategory = matchedCategoryObj.title;
      lastPage = 'main';
      const categoryIconSrc = matchedCategoryObj.icon || CATEGORY_IMAGES[matchedCategoryObj.title] || '';
      renderDrawer(drawerElement);
      const mainPage = drawerElement.querySelector('[data-cp-page="main"]');
      const categoryPage = drawerElement.querySelector('[data-cp-page="category"]');
      const answerPage = drawerElement.querySelector('[data-cp-page="answer"]');

      if (mainPage) mainPage.classList.remove('active');
      if (answerPage) answerPage.classList.remove('active');
      if (categoryPage) categoryPage.classList.add('active');
      return;
    }

    // Check if a FAQ question block was selected
    let foundCategory = '';
    let foundItem = null;
    let foundIndex = -1;

    Object.entries(faqData).forEach(([cat, list]) => {
      list.forEach((item, idx) => {
        if (item.id && (item.id === selectedBlockId || selectedBlockId.includes(item.id) || item.id.includes(selectedBlockId))) {
          foundCategory = cat;
          foundItem = item;
          foundIndex = idx;
        }
      });
    });

    if (foundItem) {
      const answerPage = drawerElement.querySelector('[data-cp-page="answer"]');
      const mainPage = drawerElement.querySelector('[data-cp-page="main"]');
      const categoryPage = drawerElement.querySelector('[data-cp-page="category"]');
      const answerQuestion = drawerElement.querySelector('[data-cp-answer-question]');
      const answerCategory = drawerElement.querySelector('[data-cp-answer-category]');
      const answerText = drawerElement.querySelector('[data-cp-answer-text]');

      currentCategory = foundCategory;
      currentIndex = foundIndex;
      currentBlockId = foundItem.id || '';
      lastPage = 'main';

      if (answerQuestion) answerQuestion.textContent = foundItem.question;
      if (answerCategory) answerCategory.textContent = foundCategory;
      if (answerText) answerText.innerHTML = foundItem.answer;

      if (mainPage) mainPage.classList.remove('active');
      if (categoryPage) categoryPage.classList.remove('active');
      if (answerPage) answerPage.classList.add('active');

      renderDrawer(drawerElement);
    }
  });
})();
